export const languages = {
  tr: {
    datePickerlang: "tr",
    headerLeft: [
      // {
      //   url: "/kiralik-villa",
      //   title: "Kiralık Villa Fiyatları | Uygun Kiralık Villa Seçenekleri 2025",
      //   text: "Kiralık Villa",
      // },
      {
        url: "/2027-villalari",
        title: "2027 Villaları",
        text: "2027 Villaları",
      },
      {
        url: "/bolgeler",
        title: "Bölgeler",
        text: "Bölgeler",
      },
      {
        url: "/satilik-villa",
        title: "Satılık Lüks Villalar - VillaVillam",
        text: "Satılık Lüks Villalar",
      },
    ],
    reservations: {
      url: "/rezervasyonlarim",
      title: "Rezervasyonlarım",
      ariaLabel: "Kullanıcı Girişi",
    },
    blogPage: {
      url: "blog-kesfet",
    },
    searchResultSlug: "arama-sonuclari",
    menu: "Menü",
    menuUpper: "MENÜ",
    close: "Kapat",
    closeUpper: "KAPAT",
    favourites: "Favoriler",
    searchPlaceholder: "Villa Ara",
    noResult: "Sonuç Bulunamadı",
    searchMinLength: "Arama yapmak için minumum 3 karakter giriniz",
    searchBoxTitle: "%20 Şimdi, Kalanını tatilde ödeme fırsatı!",
    forYou: "Size Özel",
    mobileSliderCaption1: "Havuzlu Kiralık Villalar",
    mobileSliderCaption1_balayi: "Havuzlu Balayı Villaları",
    mobileSliderCaption2: "Balayı Villaları",
    mobileSliderCaption3: "Muhafazakar Villalar",
    mobileSliderCaption3_balayi: "Muhafazakar Balayı Villaları",
    destination: "Bölge",
    addVillaDestination: "Villanın Bulunduğu Turizm Bölgesi",
    villaOptions: "Villa Seçenekleri",
    checkInOutDate: "Giriş - Çıkış Tarihi",
    customer: "Misafir",
    searchUpper: "ARA",
    select: "Seçiniz",
    selected: "seçildi",
    adult: "Yetişkin",
    child: "Çocuk",
    informationBanner1Title: "%100 Para İade Güvencesi",
    informationBanner1SubTitle: "& Ücretsiz İptal",
    informationBanner1ButtonText: "Detaylı bilgi edin",
    documentNo: "Belge No",
    informationBanner2Title:
      "Villa Villam TÜRSAB üyesi bir seyahat Acentasıdır",
    informationBanner2Title_balayi:
      "Balayı Villası Kirala TÜRSAB Seyahat Acentasıdır",
    informationBanner2ButtonText: "Doğrulama için tıklayın",
    informationBanner3Title: "Kredi Kartına 12 aya varan taksit imkanı",
    informationBanner3ButtonText: "Detaylı bilgi edin",
    productDestinationsContainerTitle: "Kiralama Bölgeleri",
    productDestinationsContainerCaption: "Hizmet verdiğimiz kiralama bölgeleri",
    productCategoriesTitle: "Villa tiplerine gözatın",
    all: "Tümü",
    showAll: "Tümünü Görüntüle",
    allRentalVillas: "Tüm Kiralık Villalar",
    nightly: "Gecelik",
    viewDetailUpper: "DETAYLI İNCELE",
    nightUpper: "GECE",
    person: "Kişi",
    bedRoom: "Yatak Odası",
    bathRoom: "Banyo",
    villaItemPrice: "Başlayan Fiyatlarla",
    villaItemPriceNightly: "gecelik fiyat",
    lastMinuteTitle: "Son Dakika {Fırsatları}",
    homeReviewLeftTitleSmall: "Yardıma mı ihtiyacın var?",
    homeReviewLeftTitle: "Villa Bulma Sihirbazı",
    homeReviewLeftText:
      "Seçmekte zorlanıyor musunuz? Formu doldurun, sizin için en uygun evleri listeleyip sunalım.",
    reviews: "Misafır Yorumları",
    allReviews: "Tüm Yorumlar",
    shortTermsTitle: "Kısa Süreli Kiralık Villalar",
    nights: "Gece",
    faqVideoTitle: "Nasıl Kiralarım ?",
    faqVideoText: "VİDEO İZLE",
    footerBannerTitle: "{Size Özel} havuzlu villada tatilini başlat.",
    footerBannerCaption:
      "Türkiye’nin mutluluğa açılan tatil kapısından dilediğin villayı kolayca kirala !",
    footerPaymentLinkButtonText:
      "Websitemiz Kredi Kartlı <br class='lg:hidden' /> Alışverişlerde 256 Bit SSL <br /> Sertifikası ile Korunmaktadır",
    pay: "GÜVENLİ ÖDE",
    copyRight: "2023 @ Tüm Hakkı Saklıdır. İzinsiz İçerik Kullanılamaz.",
    wpSupport: "WhatsApp Destek",
    wpMessage: "{Villa} Hakkında Bilgi almak istiyorum.",
    calendarUnavailable: "Dolu",
    calendarOption: "Opsiyonda",
    calendarLastMinute: "Son Dakika Fırsatı",
    lastMinuteBadge: "SON DAKİKA",
    detailLastMinuteTitle: "Son Dakika Fırsatları",
    detailLastMinuteText:
      "Bu tarihlerde boş kalan günler için özel fiyat. Fırsat, rezerve edilene kadar geçerlidir.",
    selectTheseDates: "Bu tarihleri seç",
    dateSelected: "Seçildi",
    datepickerCheckIn: "Giriş",
    datepickerCheckOut: "Çıkış Tarihi",
    warning: "Uyarı!",
    reservationUnavailableMessage:
      "Görüntülediğiniz  villa rezervasyon alınımına kapalıdır. Dilerseniz diğer villalarımızı inceleyebilirsiniz.",
    childAge: "6-12 Yaş",
    infant: "Bebek",
    infantAge: "0-5 Yaş",
    back: "Geri",
    reservationSubmitButtonText: "ÜCRETSİZ REZERVASYON TALEBİ GÖNDER",
    nameSurname: "Ad Soyad",
    email: "Email",
    phone: "Telefon",
    sendBtnText: "Gönder",
    reservationSummary: "Rezervasyon Özeti",
    accommodationAmount: "Konaklama Tutarı ({night} Gece) ",
    remainingAmount: "Kalan (Villaya girişte ödenecek)",
    takeTotalAmount: "Alınacak Toplam Tutar",
    cleaningFee: "Temizlik Ücreti",
    totalPrice: "Toplam Tutar",
    depositPrice: "Ön Ödeme Tutarı",
    watchVideo: "Videoyu İzle",
    showPhotos: "Fotoğrafları Gör",
    favourite: "Favori",
    share: "Paylaş",
    shareUpper: "PAYLAŞ",
    morePhotos: "Fotoğraf Daha",
    availabilityCalendar: "Müsaitlik Takvimi",
    sidebarReservationTitle: "Rezervasyon Yap",
    sidebarReservationSubtitle:
      "Şuan bu villayı <span class='text-orange'>{count} Kişi</span> inceliyor",
    addFavourite: "Favoriye Ekle",
    removeFavourite: "Favoriden Çıkar",
    shareViaWhatsapp: "Whatsapp ile Paylaş",
    shareViaFacebook: "Facebook ile Paylaş",
    shareViaTwitter: "Twitter ile Paylaş",
    shareViaMail: "Mail ile Paylaş",
    copyLink: "Bağlantıyı Kopyala",
    propertiesTitle: "Öne Çıkan Özellikler",
    pricesTitle: "Dönemlik Fiyatlar",
    inludedPrice: "Fiyata Dahil Olanlar",
    notIncludedPrice: "Fiyata Dahil Olmayanlar",
    information: "Bilgilendirme",
    cancellationTerms: "İptal Şartları",
    damageDeposit: "Hasar Depozito",
    checkinTime: "Giriş Saati (En Erken)",
    checkoutTime: "Çıkış Saati (En Geç)",
    discover: "Keşfet",
    poolDimensions: "Havuz Ölçüleri",
    poolType: "Havuz Tipi",
    childPool: "Çocuk Havuzu",
    indoorPool: "Kapalı Havuz",
    distancesTitle: "Ulaşım Bilgisi",
    showOnMap: "Haritada Göster",
    locationInformation: "Konum Bilgisi",
    goToLocation: "Konuma git",
    detailSimilarVillasTitle: "Benzer Villalara Gözat",
    favouritesRightTitle: "Favori Listesi",
    favouritesRightNotFound:
      "Favorilere eklenen herhangi bir villa bulunamadı.",
    FavouriteItemDetailBtnText: "Görüntüle",
    FavouriteItemRemoveBtnText: "Kaldır",
    MenubarHomeText: "Anasayfa",
    MenubarSearchText: "Adı ile Ara",
    MenubarButtonFilterText: "Filtrele",
    MenubarButtonReservationText: "Rezervasyon Yap",
    AllVillas: "Tüm Villalar",
    notDates: "Giriş/Çıkış tarihlerinizi belirtiniz.",
    reservationTitle: "<strong>{baslik}</strong> için Rezervasyon yapıyorsunuz",
    reservationSection1Title: "Kişisel Bilgilerinizi Girin",
    reservationFormNamePlaceholder: "Adınız Soyadınız",
    reservationFormEmailPlaceholder: "E-Posta Adresiniz",
    reservationFormPhonePlaceholder: "Telefon",
    reservationFormPhonePlaceholder2: "Telefon",
    reservationSection2Title: "Onay Sonrası Ödeme Şeklinizi Seçin",
    reservationPaymentAll: "Tamamı",
    paymentMethod1Title: "Havale ile Öde",
    paymentMethod1Description:
      "Ödeme tutarını Havale veya EFT ile yapmak istiyorum.",
    paymentMethod2Title: "Kredi Kartı ile Öde",
    paymentMethod2Description:
      "Ödemenizi kredi kartı ile tek çekim veya 12 aya kadar taksit ile yapabilirsiniz.",
    reservationSection3Title: "Villaya girişte dikkat edilmesi gerekenler",
    reservationDamageDeposit: "Hasar Depozito",
    reservationDamageDepositDescription:
      "Villada herhangi bir hasar olmaması halinde çıkışta iade edilecektir.",
    reservationCheckinCheckoutTime: "Giriş ve Çıkış Saatleri",
    reservationCheckinTime: "Giriş En Erken",
    reservationCheckoutTime: "Çıkış En Geç",
    contractText: "{contractName} okudum kabul ediyorum.",
    contract1: "Kiralama Sözleşmesini",
    contract2: "KVKK Aydınlatma Metnini",
    reservationSendValidationError:
      "Lütfen tüm alanların geçerli olduğundan emin olun.",
    reservationSendBtnText: "REZERVASYON TALEBİ GÖNDER",
    reservationSuccessPageTitle: "Talep Başarılı",
    reservationSuccessPageDescription:
      "Rezervasyon Numaranız: <strong class='text-black font-extrabold'>{id}</strong>",
    dear: "Sayın",
    reservationSuccessPageSuccessMessage: "Talebiniz başarıyla alınmıştır.",
    reservationSucessPageMailSendedMessage:
      "<strong class='text-black font-bold'>{mail}</strong> adresine bilgilendirme maili gönderilmiştir.;",
    error: "Hata!",
    SearchResultTitle: "Villanı Aramaya Başla",
    SearchResultFilterSummeryText: "{totalRecord} Villa Listelendi",
    SearchResultFilterOrderPlaceHolder: "Sıralama",
    orderOptions: [
      {
        value: "0",
        label: "Akıllı Sıralama",
      },
      // {
      //   value: "1",
      //   label: "Tarihe Göre (Önce En Eski)",
      // },
      // {
      //   value: "2",
      //   label: "Tarihe Göre (Önce En Yeni)",
      // },
      {
        value: "3",
        label: "Fiyata Göre (Önce En Düşük)",
      },
      {
        value: "4",
        label: "Fiyata Göre (Önce En Yüksek)",
      },
      {
        value: "5",
        label: "Kişiye Göre (Önce En Düşük)",
      },
      {
        value: "6",
        label: "Kişiye Göre (Önce En Yüksek)",
      },
    ],
    bankTransferFormTitle: "Havale Bildirim Formu",
    name: "Ad",
    surname: "Soyad",
    bankTransferFormAmount: "Gönderilen Miktar",
    bankTransferFormDate: "Gönderilen Tarih",
    bankTransferFormReceivingBank: "Alıcı Banka",
    bankTransferFormMessage: "Mesajınız",
    dateDay: "GG",
    dateMonth: "AA",
    dateYear: "YYYY",
    loginSuccess: "Giriş Başarılı",
    loadingText: "Yükleniyor",
    login: "Giriş Yap",
    bankTransferNotAuth:
      "Havale Bildirim Formu gönderebilmek için giriş yapmanız gerekiyor.",
    ProductCategoryItemSubText: "{count} villa içeriyor",
    loginLeftSubtitle: "Tekrar hoşgeldiniz,",
    loginLeftTitle: "Rezervasyon Takip",
    loginLeftCopyRight:
      "2021 @ Tüm Hakkı Saklıdır. İzinsiz İçerik Kullanılamaz.",
    welcome: "Hoşgeldiniz",
    loginRightDescription:
      "E-posta adresiniz ve Rezervasyon onay numaranız ile rezervasyonlarını bu bölümden takip yada kontrol edebilirsiniz. Rezervasyonunuz ile ilgili herhangi bir sorunla karşılaştığınız takdirde müşteri hizmetlerimizle acil olarak {contact}",
    loginRightDescriptionContactLink: "iletişime geçiniz.",
    loginFormEmail: "E-Posta Adresiniz",
    loginReservationNumber: "Rezervasyon Onay Kodu",
    loginRightDescriptionBottom:
      "Bu bölüme giriş yapabilmeniz için, daha önceden rezervasyon yapmış ve rezervasyonunuzun onaylanarak sizlere mail ve onay kodunun ulaşmış yada rezervasyonun kesinleşmiş olması gerekir. Sadece talep göndermiş müşterilerimiz bu bölüme ulaşamaz.",
    logout: "Çıkış Yap",
    reservationsTab1: "Aktif Rezervasyonlarınız",
    reservationsTab2: "Geçmiş Rezervasyonlarınız",
    reservationsTab1Error: "Aktif Rezervasyon Bulunamadı",
    reservationsTab2Error: "Geçmiş Rezervasyon Bulunamadı",
    ReservationStatus0: "Onay Bekliyor",
    ReservationStatus1: "Ödeme Bekliyor",
    ReservationStatus1ActionBtn: "Ödeme Bildirimi Yap",
    ReservationStatus1ActionCompleted: "Ödeme Bildirimi Yapıldı",
    ReservationStatus1ActionBtn2: "Kredi Kartı ile Öde",
    ReservationStatus3: "Onaylandı",
    ReservationStatus3Text: "Ödendi",
    ReservationStatus3ActionBtn: "Ödeme Bildirimi Yap",
    ReservationStatus3ActionBtn2: "Lütfen Misafir bilgilerini giriniz",
    ReservationStatus3ActionBtn2Completed: "Kişi Bilgileri Girildi",
    ReservationStatus4: "İptal Edildi",
    reservationNo: "Rez. No",
    reservationDate: "İşlem Tarih / Saat",
    reservationCustomerName: "Müşteri Ad Soyad",
    reservationDate1: "Giriş Tarihi",
    reservationDate2: "Çıkış Tarihi",
    reservationtionPrice: "Ödeme Tutarı",
    reservationGuestInformationTitle:
      "{reservationId}’nolu Rezervasyonunuz için {name} bilgilerinizi giriniz",
    reservationGuestInformationTitleName1: "Misafir",
    reservationGuestInformationTitleName2: "Fatura",
    reservationGuestInformationSubTitle:
      "En fazla {count} Kişi konaklayabilirsiniz.",
    GuestInformationTitle: "Misafir {no} bilgileri",
    GuestInformationName: "Ad Soyad",
    GuestInformationGender: "Cinsiyet",
    GuestInformationGenderMale: "Erkek",
    GuestInformationGenderFemale: "Kadın",
    GuestInformationBirthDate: "Doğum Tarihi",
    GuestInformationBirthPlace: "Doğum Yeri",
    GuestInformationPassaport: "Pasaport No",
    GuestInformationTc: "Tc",
    GuestInformationNotTurkeyPeople: "Tc Vatandaşı Değilim",
    goBack: "Geri Dön",
    save: "Kaydet",
    GuestInformationInvoiceType: "Fatura Tipi",
    GuestInformationInvoiceTypeOption1: "Bireysel",
    GuestInformationInvoiceTypeOption2: "Kurumsal",
    GuestInformationInvoiceTypeOption1Name: "Ad Soyad",
    GuestInformationInvoiceTypeOption2Name: "Şirket Adı",
    GuestInformationInvoiceTaxOffice: "Vergi Dairesi",
    GuestInformationInvoiceTaxNumber: "Vergi Numarası",
    address: "Adres",
    GuestInformationSuccessfullyTitle: "Misafir Bilgileri Başarıyla Alındı",
    GuestInformationSuccessfullyDescription:
      "Misafir bilgilerinizin özeti size e-posta ile gönderildi. Eğer bir hata olduğunu düşünüyorsanız lütfen Müşteri Hizmetlerimizle iletişime geçin.",
    PayByCreditCardTitle: "{price} ödemeyi",
    PayByCreditCardCaption: "Banka veya Kredi Kartı ile Öde",
    PayByCreditCardFormName: "Ad Soyad",
    PayByCreditCardFormCardNumber: "Kart üzerindeki 12 haneli numara",
    PayByCreditCardFormSubmit: "Öde",
    PayByCreditCardRightTitle: "{night} Gece Konaklama",
    PaymentAuthRequired: "Ödeme yapmak için giriş yapmanız gerekiyor.",
    installementFull: "Tek Çekim",
    installement: "Taksit",
    paymentSuccess: "Ödeme Başarılı",
    paymentSuccessDescription: "Bu pencereyi kapatabilirsiniz.",
    paymentTryAgain: "Lütfen Tekrar Deneyiniz",
    getOfferStep1Title1: "Villa bulma sihirbazına",
    getOfferStep1Title2: "Hoşgeldiniz",
    getOfferStep1Caption1: "Aradığın villayı",
    getOfferStep1Caption2: "bulmakta zorlanıyor musun ?",
    getOfferStep1SubTitle: "Sadece 5 adımda aradığın villayı kolayca bul",
    getOfferNextBtn: "Sonraki",
    getOfferPrevBtn: "Önceki",
    getOfferSendBtn: "Formu Gönder",
    getOfferStep2Title: "NASIL BİR VİLLADA TATİL YAPMAK İSTERSİNİZ",
    getOfferStep2Option1: "EKONOMİK",
    getOfferStep2Option2: "ORTA",
    getOfferStep2Option3: "LÜKS",
    getOfferStep3Title: "TATİLİNİZİ NE İÇİN PLANLIYORSUNUZ ?",
    getOfferStep3Option1: "Balayı veya Özel Gün",
    getOfferStep3Option2: "Aile veya Arkadaşlarla",
    getOfferStep4Title: "VİLLANIZDA OLMASINI İSTEDİĞİNİZ ÖZELLİKLER",
    getOfferStep5Title: "BİLGİLERİNİZ",
    getOfferFormFullName: "Ad Soyad",
    getOfferFormEmail: "Email Adresiniz",
    getOfferFormPhone: "Telefon Numaramız",
    getOfferFormPerson: "Kişi Sayısı",
    getOfferFormAdult: "Yetişkin",
    getOfferFormChild: "Çocuk",
    getOfferFormInfant: "Bebek",
    getOfferFormError: "Bir sorun oluştu",
    getOfferModalTitle: "TEŞEKKÜRLER",
    getOfferModalCaption:
      "Villa bulma sihirbazı size en uygun olan seçenekleri bulmak için çalışmaya başladı",
    getOfferModalDescription:
      "En kısa zamanda sizin için seçilen villalar sms ve email olarak gönderilecektir",
    blogSidebarSearchTitle: "Arama Yapın",
    blogSidebarSearchPlaceHolder: "Blog Ara",
    blogSidebarList1Title: "Son Yazılar",
    blogSidebarList2Title: "Popüler Yazılar",
    blogItemReadBtn: "Devamını Oku",
    bankItemBankName: "Banka Adı",
    bankItemBankBranch: "Şube Adı-Kodu",
    bankItemBankAccountName: "Hesap Adı",
    bankItemBankIban: "İban No",
    checkinInformationTitle: "Rezervasyon detaylarınız",
    viewInvoice: "Fatura Bilgilerini Gör",
    viewContract: "Sözleşme Bilgilerini Gör",
    customerInformations: "Müşteri Bilgileri",
    villaManager: "Villa Sorumlusu/Görevlisi",
    callNow: "Hemen Ara",
    sendMessageViaWp: "Whatsapp’dan yaz",
    earliest: "En Erken",
    latest: "En Geç",
    paymentInformations: "Ödeme Bilgileri",
    paymentOwnerInformation: "Ödeme Bilgileri Detayı",
    remaining: "Kalan",
    accommodationPrice: "Toplam Konaklama Tutarı",
    paymentCheckin: "Villaya Girişte Yapılması Gereken Ödeme",
    creditcardNotAccepted:
      "(Kredi kartı geçerli <span class='underline'>değildir</span>)",
    entranceInformationDamageDeposit:
      "Ayrıca {hasar} değerinde hasar depozitosu alınacaktır.",
    entranceInformationLocationErrorOwner:
      "Lütfen Misafiriniz ile irtibata geçip konum bilgisi iletiniz!",
    entranceInformationLocationErrorCustomer:
      "Lütfen Villa Sorumlusu/Görevlisi ile irtibata geçip konum bilgisi isteyiniz !",
    UnconditionalmoneyTitle: "24 Saat İçerisinde",
    UnconditionalmoneySubTitle: "Koşulsuz Para İadesi",
    UnconditionalmoneyDescription:
      "*Rezervasyonun onaylanmasını takip eden 24 saat içerisinde İPTAL gerçekleşirse ziyaretçi ödemiş olduğu kaporayı koşulsuz iade alır.",
    UnconditionalmoneyDescription2:
      "Giriş tarihi en erken 21 gün içerisindeki olan rezervasyonlarda geçerli değildir.",
    discount: "İndirim",
    discountedAccommodationAmount: "İndirimli Konaklama Tutarı",
    appliedDiscount: "{code} kodu uygulandı",
    ihaveapromotioncode: "Promosyon Kodum Var",
    promotionCode: "Promosyon Kodu",
    apply: "Uygula",
    callCenterName: "Müşteri Hizmetleri",
    allVillasCta: "Tüm kiralık villalar",
    allVillasCtaSub: "Tarih seçmeden tüm villalara göz atın",
    allVillasCtaStrip: "Tarih seçmeden tüm kiralık villalara göz atın",
    allVillasCtaRest: "ve diğer tüm bölgeler",
    disableCalendarRules: "Takvim Kurallarına Uyma",
    roomCount: "Oda Sayısı",
    paybackDamageInfo:
      "Girişte alınacak, hasar olmaması durumunda çıkışta tarafınıza iade edilecektir.",
    paymentByCompany: "Acenta tarafından gönderilecek tutar",
    paymentByCompanyInfo:
      "Giriş tarihinden sonraki 1-5 iş günü içerisinde hesabınıza gönderilecektir.",
    accountDelete: "Hesabımı Sil",
    rezervationCode: "Rezervasyon Kodu",
    memberLogin: "Üye Girişi",
    noAccount: "Hesabınız yok mu?",
    register: "Kaydol",
    forgotPassword: "Şifremi Unuttum",
    loginError: "Giriş yapılırken bir hata oluştu.",
    newPassword: "Yeni Şifre",
    confirmPassword: "Şifre Tekrarı",
    updatePassword: "Şifreyi Güncelle",
    otpCode: "Doğrulama Kodu",
    verifyCode: "Kodu Doğrula",
    resendCode: "Kodu Tekrar Gönder",
    otpRequired: "Doğrulama kodu zorunludur",
    otpLength: "Kod 6 haneli olmalıdır",
    otpError: "Kod doğrulanamadı.",
    otpResendSuccess: "Doğrulama kodu tekrar gönderildi.",
    otpResendError: "Kod tekrar gönderilemedi.",
    passwordRequired: "Şifre zorunludur",
    passwordMin: "Şifre en az 6 karakter olmalıdır",
    passwordsNotMatch: "Şifreler eşleşmiyor",
    passwordUpdateSuccess: "Şifreniz başarıyla güncellendi!",
    passwordUpdateError: "Şifre güncellenemedi.",
    completeRegistration: "Kaydı Tamamla",
    nameRequired: "Ad zorunludur",
    surnameRequired: "Soyad zorunludur",
    emailRequired: "E-posta zorunludur",
    emailInvalid: "Geçerli bir e-posta giriniz",
    registrationSuccess: "Hesabınız oluşturuldu!",
    registrationError: "Kayıt tamamlanamadı.",
    password: "Şifre",
    sendResetCode: "Sıfırlama Kodu Gönder",
    backToLogin: "Giriş Yap'a Dön",
    createNewPassword: "Yeni Şifre Oluştur",
    continue: "Devam Et",
    phoneRequired: "Telefon numarası zorunludur",
    phoneInvalid: "Geçerli bir numara giriniz",
    operationFailed: "İşlem başarısız.",
    newPasswordRequired: "Yeni şifre zorunludur",
    confirmPasswordRequired: "Şifre tekrarı zorunludur",
    // --- Yeni metinler (site 2 ceviri) ---
    faqTitle: "Sıkça Sorulan Sorular",
    instagramSubtitle: "Kiralık Tatil Villaları",
    instagramText: "Fethiye ve çevresindeki en özel villaları keşfetmek, misafir deneyimlerimizi görmek için bizi takip edin.",
    instagramFollow: "Instagram'da Takip Et",
    discountedBadge: "İndirimli",
    instantBooking: "Anında Rezervasyon",
    googleReviewsTitle: "Google Misafir Yorumları",
    googleReviewsCount: "1.179 Gerçek Yorum",
    viewAllReviews: "Tüm yorumları görüntüle",
    excellent: "Mükemmel",
    weekly: "Haftalık",
    workingHours: "Çalışma Saatleri",
    noResultFound: "Sonuç Bulunamadı",
    mobileMenuLabel: "Mobil Menü",
    copied: "Kopyalandı!",
    reviewCtaTitle: "Misafirimiz Oldunuz Mu?",
    reviewCtaThisVilla: "Bu villadaki",
    reviewCtaText: "tatiliniz nasıldı? Deneyiminizi bizimle ve diğer misafirlerle paylaşarak onlara da yol gösterebilirsiniz.",
    ministryOfTourism: "T.C Kültür ve Turizm Bakanlığı",
    applicationNo: " Başvuru No: ",
    applicationInProgress: " Başvuru Sürecinde",
    cancel: "İptal",
    clearSelection: "Seçimi kaldır",
    sidebarPayNowText: "Ön onay beklemeden ödemenizi yapın ve rezervasyonunuzu tamamlayın.",
    bedroom1: "Yatak Odası 1",
    bedroom2: "Yatak Odası 2",
    garden: "Bahçe",
    doubleBed: "Çift Kişilik Yatak",
    bathroomDoubleBed: "Banyo Çift Kişilik Yatak",
    poolLength: "Boy",
    poolWidth: "En",
    poolDepth: "Derinlik",
    directionsAria: "Ofis konumumuz için yol tarifi al",
    timeAlmostUp: "Süre Dolmak Üzere!",
    paymentTime: "Ödeme Süresi",
    timeLeftToComplete: "Rezervasyonunuzu tamamlamak için kalan zaman",
    dayShort: "Gün",
    feedbackThanks: "Geri bildiriminiz için teşekkür ederiz...",
    feedbackChooseRating: "Lütfen geçerli bir puan seçiniz.",
    feedbackAsk: "Web sitemiz yenilendi, yeni web sitemizi değerlendirmek ister misiniz?",
    no: "Hayır",
    yourRating: "Puanınız",
    pleaseSelect: "Seçiniz",
    certificateLabel: "Belge",
    certificateNo: " No : ",
    rentableNow: "Hemen Kiralanabilir",
    errorTitle: "Hata",
    warningTitle: "Uyarı",
    attention: "Dikkat",
    hoursLabel: "Saat",
    minutesLabel: "Dakika",
    secondsLabel: "Saniye",
    followUs: "Takipte Kal",
    ourOffice: "Ofisimiz",
    getDirections: "Yol Tarifi Al",
    footerAddress: "Akarca Mah. Adnan Menderes Bulvarı No:205/C 1-2-3 Fethiye/Muğla",
    learnMore: "Bilgi al",
    favouritesAria: "Favoriler",
    favouriteAria: "Favori",
    writeReviewShort: "Yorum Yaz",
    googleWriteReview: "Google'da Yorum Yap",
    nightLabel: "Gece",
    moreInfo: "Detaylı Bilgi",
    free: "Ücretsiz",
    dateLabel: "Tarih",
    amountLabel: "Tutar",
    statusLabel: "Durum",
    feeLabel: "Ücret",
    statusAvailable: "Mevcut",
    statusUnavailable: "Devredışı",
    serviceFreePre: "Kullanılabilir tarihler için bu hizmetten",
    serviceFreeStrong: "Ücretsiz",
    serviceFreePost: "faydalanabilirsiniz. ☺️",
    servicePaidPre: "Kullanılabilir tarihler için toplam",
    servicePaidPost: "ücret alınacaktır.",
    mobileAppDiscount: "Mobil uygulamaya özel indirim",
    promoCodeDiscount: "Promosyon Kodu İndirimi",
    heatedPool: "Isıtmalı Havuz",
    optionalServices: "Opsiyonel Hizmetler",
    heatingPoolTitle: "Isıtma Havuzu Ücretleri ve Kullanılabilirlik Durumu",
    notUsable: "Kullanılamaz",
    usable: "Kullanılabilir",
    closeBtn: "Kapat",
    wantHeatedPool: "Isıtmalı havuzdan faydalanmak istiyorum",
    heatedPoolDatesPre: "Isıtma Hizmeti alabileceğiniz tarihleri görmek için",
    heatedPoolDatesClick: "tıklayınız",
    availableDatesText: "Bu tesis için rezervasyon yapılabilir uygun tarihler",
    selectBtn: "Seç",
    loadingDots: "Yükleniyor...",
    continueAnyway: "Yine de Devam Et",
    availableDatesWarning: "Genellikle olumsuz sonuçlanmaktadır. Ama dilerseniz sizler için tekrar değerlendirebiliriz veya alternatif tarihlerden seçim yapabilirsiniz.",
    payNow: "Şimdi öde",
    contactAddress: "Adres",
    contactPhoneEmail: "Telefon & Email",
    contactShare: "Paylaş",
    contactForm: "İletişim Formu",
    contactFullName: "Adınız Soyadınız",
    contactPhone: "Telefon Numaranız",
    contactEmail: "Email Adresiniz",
    contactSubject: "Konu",
    contactMessage: "Mesajınız",
    contactSecurityCode: "Güvenlik Kodu",
    contactSecurityCodeEnter: "Güvenlik Kodunu Giriniz",
    contactSendForm: "FORMU GÖNDER",
    contactMap: "Harita",
    creditCardInstantNote: "Kredi kartı ile ödeme yöntemini tercih ettiğinizde, rezervasyonunuz onay sürecine gerek kalmadan anında tamamlanacak ve kesinleşecektir.",
    cardNumberLength: "Kart numarası 12 haneli olmalıdır.",
    paymentStatusChecking: "Ödeme durumu kontrol ediliyor...",
    paymentSuccessToast: "Ödeme Başarılı",
    closeWindowAfterPayment: "Ödemenizi yaptıktan sonra bu pencereyi kapatabilirsiniz.",
    clickToPay: "Ödeme Yapmak İçin Tıklayınız",
    installments369: "Tüm banka kartlarına 3-6-9 taksit imkanı",
    bankRatesApply: "Bankaların belirtmiş olduğu oranlar geçerlidir",
    successTitle: "Başarılı",
    paymentReceived: "Ödemeniz başarıyla alınmıştır.",
    paymentInfoSentTo: "adresine ödeme bilgileri gönderilmiştir.",
    contactAndPaymentInfo: "İletişim ve Ödeme Bilgileri",
    fullNameLabel: "İsim Soyisim",
    creditCardInfo: "Kredi Kartı Bilgileri",
    cardNumberLabel: "Kart Numarası",
    loadingShort: "Yükleniyor",
    payBtn: "Ödeme Yap",
    sslNotice: "{domain} üzerinden yapacak olduğunuz ödeme işlemleri 256-Bit SSL Sertifikası ile şifrelenerek banka tarafına iletilir. Bankanız ile {site} arasında güvenli olarak bilgi akışı sağlanır ve kart bilgileriniz hiçbir veritabanına kaydedilmez.",
    heatedPoolFee: "Isıtmalı Havuz Ücreti",
    sliderCaptionDefault: "Size özel havuzlu villada tatilini başlat",
    ownerWelcomeBack: "Tekrar hoşgeldiniz,",
    ownerPanelTitle: "Ev Sahibi Yönetim Paneli",
    ownerCopyright: "2021 @ Tüm Hakkı Saklıdır. İzinsiz İçerik Kullanılamaz.",
    ownerWelcome: "Hoşgeldiniz.",
    ownerIntroPre: "Size verilen E-posta adresi ve şifre ile evlerinizi bu bölümden takip yada kontrol edebilirsiniz. Evleriniz ile ilgili herhangi bir sorunla karşılaştığınız takdirde müşteri hizmetlerimizle acil olarak",
    ownerIntroLink: "iletişime geçiniz.",
    ownerLoginError: "Kullanıcı adı veya şifre hatalı.",
    usernameLabel: "Kullanıcı Adı",
    passwordLabel2: "Şifre",
    loginBtn2: "Giriş Yap",
    advertiseQPre: "",
    advertiseQStrong: "Villa ",
    advertiseQPost: "Sahibi Misiniz ?",
    advertiseFormReceived: "Formunuz alınmıştır. İlgili departmanımız en kısa sürede dönüş sağlayacaktır. İlginize teşekkür ederiz.",
    poolPrivate: "Özel Havuz",
    poolShared: "Ortak Havuz",
    poolNone: "Havuz Yok",
    seaViewLabel: "Deniz Manzarası",
    yesLabel: "Var",
    noLabel: "Yok",
    yourMessagePlaceholder: "Mesajıınız",
    advInfo1Title: "DOĞRU FİYAT VE KAZANÇ BELİRLEME ",
    advInfo1Text: "Villanızın özellikleri, kapasitesi, konumu gibi kriterleri göz önünde bulundurarak muadilleriyle kıyaslar; en isabetli fiyatlandırma çalışmasını yaparak sezonluk kazanç senaryosunu da detaylandırabiliriz.",
    advInfo2Title: "PROFİL VE İLAN YÖNETİMİ ",
    advInfo2Text: "Villanızı uzman ekibimizle birlikte isabetli reklam çalışmaları yaparak doğru misafir kitlesine sunarız. Etkili sosyal medya yönetimi bilinci ve deneyimi ile en yüksek doluluğa ulaşmanız için titizlikle çalışmaktayız.",
    advInfo3Title: "7/24 MİSAFİR DESTEK HATTI ",
    advInfo3Text: "7 Gün / 24 Saat Call Center hizmeti ile misafirlerimizin talep ve sorularına anında dönüş sağlamaktayız. Gün ve saat farketmeksizin sürekli destek hattı ile hizmet vermekteyiz.",
    advInfo4Title: "PROFESYONEL FOTOĞRAF & VİDEO ÇEKİMLERİ ",
    advInfo4Text: "Villa tanıtımında en önemli faktörlerden birisi olan fotoğraflandırma işlemini profesyonel ekibimiz ile sağlamaktayız. Çekimlerimiz reklam çalışmaları ve sosyal medya hesaplarında etkin kullanıma uygun yöntemler dikkate alınarak titizlikle yapılmaktadır.",
    advInfo5Title: "DEĞERLENDİRME VE BİLGİLENDİRME",
    advInfo5Text: "Villanızın maksimum doluluğa ulaşması amacıyla projenizin başından sonuna kadar deneyimli kadromuzdan iç ve dış mekan dizaynı, donanımsal özelliklerin katkıları gibi konularda değerlendirme ve detaylı bilgi edinebilir, bu sayede daha yüksek rezervasyon talebi alabilirsiniz.",
    ptdTitle1: "Kapıda",
    ptdTitle2: "Ödeme",
    ptdTitle3: "Sistemi",
    ptdP1: "rezervasyon aşamasında villaya göre %15 ile %40 arasında ÖN ÖDEME talep etmektedir.",
    ptdP2: "Kalan ödemenizi Villa’ya giriş günü Villa Sahibine ödeme yapabilirsiniz.",
    ptdP3: "Villa sahibinin KALAN Ödemenizi nasıl talep ettiği rezervasyon aşamasında size gelen MAİL içerisinde belirtilmektedir.",
    refundTitle1: "Villa Sahibi Kaynaklı Problemlerde",
    refundTitle2: "%100 Para İadesi",
    refundP1Pre: "Tatiliniz için rezerve ettiğiniz villa’ya giriş saatinizden itibaren 6 saat içerisinde villa sahibine ulaşamamanız veya görsellerde gördüğünüz villanın farklı olması durumunda ( mobilya ve dekorasyon değişiklikleri dışında ) geçerlidir. Ödemiş olduğunuz tüm tutar size",
    refundP1Strong: "geri iade",
    refundP1Post: "edilir.",
    refundP2: "yaşanan bu mağduriyeti gidermek adına aynı bölgede tatilinize devam edebilmeniz için müsait olan villalarda komisyon kazancı yok sayılarak indirimli bir şekilde size Satış Danışmanı arkadaşlarımız yardımcı olmaktadır.",
    refundP3: "Bu durumların haricinde tatil esnasında yaşayabileceğiniz sorunlarda {site} yine sizlere yaşanan sorunun en hızlı şekilde çözülmesinde sorunun çözülemeyecek bir hal aldığı durumlarda farklı bir villada müsaitlik olması durumunda geçişinizin sağlanması adına yardımcı olmaktadır",
    securaTitle1: "Güvenli",
    securaTitle2: "Ödeme",
    securaTitle3: "Sistemi",
    securaP1Pre: "Bir",
    securaP1Company: "Coşkunlar Ticaret Emlak Turizm İnşaat Limited Şirketi",
    securaP1Post: "Kuruluşudur.",
    securaP2: "Sitemizde SSL protokolü şifreleme sistemi (çözülmesi imkansız), 256 Bit secure site ile 3D Secure ödeme sistemi kullanılmaktadır.",
    securaP3: "Sanal Pos Sistemi Üzerinden Kredi Kartınızla veya Resmi Şirket Hesaplarımıza Havale/Eft Yapabilirsiniz.",
    securaPolicyTitle: "İşbu Gizlilik Politikası:",
    securaPolicyText: "{domain} adresini ziyaret eden ve kullanan tüm kullanıcıları kapsamakta olup; peşinen kabul edilmiştir. {domain} yi kullanan ziyaretçilerin doğrudan ve/veya dolaylı olarak bizlere sunduğu verilerden aşağıda bahsedilmiştir. Bu veriler, Kiralama ve Kullanım sözleşmesi, Gizlilik Politikası şartları gereği uygun olan haller dahilinde kullanılmakta olup; bu uygun olan hallerin dışında kullanılmamaktadır.",
    installPre: "Rezervasyonunuzu şimdi yapın,",
    installMid: "kredi kartına taksit imkanıyla rahat rahat ödeyin. {site} tüm kredi kartlarına 12 aya varan taksit imkanı sunmaktadır.",
    installNote: "Taksit seçeneklerinde vade farkı oranları kullandığınız banka tarafından belirlenmektedir. Rezervasyon işleminizden önce ilgili bankanın uyguladığı vade farkı oranlarını inceleyebilir, taksit imkanından yararlanabilirsiniz.",
    installUpTo: "12 aya varan taksit imkanı",
    installTursab: "{site} Turizm Seyahat Acentası TÜRSAB A-14264 Belge ile T.C Turizm Bakanlığına bağlıdır.",
    paidAccommodationAmount: "Ödenen Konaklama Tutarı",
    remainingAccommodationAmount: "Kalan Konaklama Tutarı",
  },
  en: {
    datePickerlang: "en-US",
    headerLeft: [
      {
        url: "/villa-for-rent",
        title: "Villa for Rent",
        text: "Villa for Rent",
      },
      {
        url: "/2027-villas",
        title: "2027 Villas",
        text: "2027 Villas",
      },
      {
        url: "/regions",
        title: "Rental Regions",
        text: "Regions",
      },
    ],
    reservations: {
      url: "/my-reservations",
      title: "My Reservations",
      ariaLabel: "My Reservations",
    },
    blogPage: {
      url: "blog-discover",
    },
    searchResultSlug: "search-result",
    menu: "Menu",
    menuUpper: "MENU",
    close: "Close",
    closeUpper: "CLOSE",
    favourites: "Favourites",
    searchPlaceholder: "Search Villa",
    noResult: "No Result",
    searchMinLength: "Enter minimum 3 characters to search",
    searchBoxTitle: "Pay the remaining part of your vacation later!",
    forYou: "For You",
    mobileSliderCaption1: "Villas with Pool",
    mobileSliderCaption2: "Honeymoon Villas",
    mobileSliderCaption3: "Conservative Villas",
    destination: "Destination",
    addVillaDestination: "Location",
    villaOptions: "Villa Options",
    checkInOutDate: "Dates",
    customer: "Guests",
    searchUpper: "SEARCH",
    select: "Select",
    selected: "selected",
    adult: "Adult",
    child: "Child",
    informationBanner1Title: "100% Money Back Assurance",
    informationBanner1SubTitle: "& Free Cancellation",
    informationBanner1ButtonText: "View Details",
    documentNo: "Document No.",
    informationBanner2Title: "Villa Villam is a member travel agency of TÜRSAB",
    informationBanner2ButtonText: "Click for verification",
    informationBanner3Title: "Up to 12 monthly installments by credit card",
    informationBanner3ButtonText: "View Details",
    productDestinationsContainerTitle: "Rental Regions",
    productDestinationsContainerCaption: "Rental areas we serve",
    productCategoriesTitle: "Browse villa types",
    all: "All",
    showAll: "View All",
    allRentalVillas: "All Rental Villas",
    nightly: "Night",
    viewDetailUpper: "VIEW DETAILS",
    nightUpper: "NIGHT",
    person: "Person",
    bedRoom: "Bedroom",
    bathRoom: "Bathroom",
    villaItemPrice: "Cheapest",
    villaItemPriceNightly: "nightly",
    lastMinuteTitle: "Last Minute {Deals}",
    homeReviewLeftTitleSmall: "Do you need help?",
    homeReviewLeftTitle: "Villa Finding Wizard",
    homeReviewLeftText:
      "Having trouble choosing? Fill out the form and we will list and present the most suitable houses for you.",
    reviews: "Guest Comments",
    allReviews: "All Comments",
    shortTermsTitle: "Short Terms Rental Villas",
    nights: "Nights",
    faqVideoTitle: "How do I rent?",
    faqVideoText: "WATCH VIDEO",
    footerBannerTitle: "{Start} your vacation in a villa with a private pool.",
    footerBannerCaption:
      "Easily rent the villa you want from Turkey's holiday gate to happiness!",
    footerPaymentLinkButtonText:
      "Our Website is Protected with a 256 Bit SSL <br /> Certificate for Credit Card <br class='lg:hidden' /> Purchases",
    pay: "PAY NOW",
    copyRight:
      "2023 @ All Rights Reserved. Content Cannot Be Used Without Permission.",
    wpSupport: "WhatsApp Support",
    wpMessage: "I want to get information about {Villa}.",
    calendarUnavailable: "Unavailable",
    calendarOption: "Option",
    calendarLastMinute: "Last Minute Deal",
    lastMinuteBadge: "LAST MINUTE",
    detailLastMinuteTitle: "Last Minute Deals",
    detailLastMinuteText:
      "Special price for the remaining days on these dates. Valid until booked.",
    selectTheseDates: "Select these dates",
    dateSelected: "Selected",
    datepickerCheckIn: "Check-in",
    datepickerCheckOut: "Check-out Date",
    warning: "Warning!",
    reservationUnavailableMessage:
      "The villa you are viewing is not available for reservations. If you wish, you can check out our other villas.",
    childAge: "6-12 Age",
    infant: "Infant",
    infantAge: "0-5 Age",
    back: "Back",
    reservationSubmitButtonText: "SEND A FREE BOOKING REQUEST",
    nameSurname: "Name & Surname",
    email: "Email",
    phone: "Phone",
    sendBtnText: "Send",
    reservationSummary: "Reservation Summary",
    accommodationAmount: "Accommodation Amount ({night} nights) ",
    remainingAmount: "Remaining (to be paid upon arrival)",
    takeTotalAmount: "Take Total Amount",
    cleaningFee: "Cleaning Fee",
    totalPrice: "Total Price",
    depositPrice: "Deposit Price",
    watchVideo: "Watch Video",
    showPhotos: "Show Photos",
    favourite: "Like",
    share: "Share",
    shareUpper: "SHARE",
    morePhotos: "More Photos",
    availabilityCalendar: "Availability Calendar",
    sidebarReservationTitle: "Reservation",
    sidebarReservationSubtitle:
      "<span class='text-orange'>{count} people</span> watching now",
    addFavourite: "Like",
    removeFavourite: "Unlike",
    shareViaWhatsapp: "Share via Whatsapp",
    shareViaFacebook: "Share via Facebook",
    shareViaTwitter: "Share via Twitter",
    shareViaMail: "Share via Mail",
    copyLink: "Copy Link",
    propertiesTitle: "Highlights",
    pricesTitle: "Prices",
    inludedPrice: "What's Included in the Price",
    notIncludedPrice: "What's Not Included in the Price",
    information: "Information",
    cancellationTerms: "Cancellation Terms",
    damageDeposit: "Damage Deposit",
    checkinTime: "Check-in Time (Earliest)",
    checkoutTime: "Check-out Time (Latest)",
    discover: "Discover",
    poolDimensions: "Pool Dimensions",
    poolType: "Pool Type",
    childPool: "Child Pool",
    indoorPool: "Indoor Pool",
    distancesTitle: "Transportation Information",
    showOnMap: "Show on Map",
    locationInformation: "Location information",
    goToLocation: "Go to location",
    detailSimilarVillasTitle: "Browse Similar Villas",
    favouritesRightTitle: "Favourites",
    favouritesRightNotFound: "No villas added to favorites were found.",
    FavouriteItemDetailBtnText: "View",
    FavouriteItemRemoveBtnText: "Remove",
    MenubarHomeText: "Home",
    MenubarSearchText: "Search",
    MenubarButtonFilterText: "Filter",
    MenubarButtonReservationText: "Booking",
    AllVillas: "All Villas",
    notDates: "Please specify your Entry/Exit dates.",
    reservationTitle:
      "You are making a reservation for <strong>{baslik}</strong>",
    reservationSection1Title: "Enter Your Personal Information",
    reservationFormNamePlaceholder: "Name Surname",
    reservationFormEmailPlaceholder: "Email",
    reservationFormPhonePlaceholder: "Phone",
    reservationFormPhonePlaceholder2: "Phone",
    reservationSection2Title: "Choose Your Payment Method After Approval",
    reservationPaymentAll: "All",
    paymentMethod1Title: "Pay by Bank Transfer",
    paymentMethod1Description:
      "I want to make the payment amount by Money Order or EFT.",
    paymentMethod2Title: "Pay by Credit Card",
    paymentMethod2Description:
      "You can make your payment by credit card in one payment or in installments up to 12 months.",
    reservationSection3Title: "Things to consider when entering the villa",
    reservationDamageDeposit: "Damage Deposit",
    reservationDamageDepositDescription:
      "If there is no damage to the villa, it will be refunded upon departure.",
    reservationCheckinCheckoutTime: "Check-in and Check-out Times",
    reservationCheckinTime: "Check-in Time ",
    reservationCheckoutTime: "Check-out Time ",
    contractText: "I have read and accept the {contractName}",
    contract1: "Rental Agreement",
    contract2: "KVKK Clarification Text",
    reservationSendValidationError: "Please fill in all the required fields.",
    reservationSendBtnText: "SEND RESERVATION REQUEST",
    reservationSuccessPageTitle: "Request Successful",
    reservationSuccessPageDescription:
      "Reservation Number: <strong class='text-black font-extrabold'>{id}</strong>",
    dear: "Dear",
    reservationSuccessPageSuccessMessage:
      "Your request has been received successfully.",
    reservationSucessPageMailSendedMessage:
      "An informative e-mail was sent to  <strong class='text-black font-bold'>{mail}</strong>",
    error: "Error!",
    SearchResultTitle: "Start Searching for Your Villa",
    SearchResultFilterSummeryText: "{totalRecord} Villas Listed",
    SearchResultFilterOrderPlaceHolder: "Sort",
    orderOptions: [
      {
        value: "0",
        label: "Smart Sorting",
      },
      // {
      //   value: "1",
      //   label: "By Date (Oldest First)",
      // },
      // {
      //   value: "2",
      //   label: "By Date (Newest First)",
      // },
      {
        value: "3",
        label: "By Price (Lowest First)",
      },
      {
        value: "4",
        label: "By Price (Highest First)",
      },
      {
        value: "5",
        label: "By Person (Lowest First)",
      },
      {
        value: "6",
        label: "By Person (Highest First)",
      },
    ],
    bankTransferFormTitle: "Transfer Notification Form",
    name: "Name",
    surname: "Surname",
    bankTransferFormAmount: "Amount Sent",
    bankTransferFormDate: "Sent Date",
    bankTransferFormReceivingBank: "Receiving Bank",
    bankTransferFormMessage: "Message",
    dateDay: "DD",
    dateMonth: "MM",
    dateYear: "YYYY",
    loginSuccess: "Login Success",
    loadingText: "Loading",
    login: "Login",
    bankTransferNotAuth:
      "You need to log in to send the Bank Transfer Notification Form.",
    ProductCategoryItemSubText: "{count} villas",
    loginLeftSubtitle: "Welcome back,",
    loginLeftTitle: "Reservation Tracking",
    loginLeftCopyRight:
      "2021 © All Rights Reserved. Unauthorized Content May Not Be Used.",
    welcome: "Welcome",
    loginRightDescription:
      "You can track or check your reservations from this section with your email address and reservation confirmation number. If you encounter any problems with your reservation, please contact our customer service immediately {contact}",
    loginRightDescriptionContactLink: "contact us.",
    loginFormEmail: "Your Email Address",
    loginReservationNumber: "Reservation Confirmation Code",
    loginRightDescriptionBottom:
      "To access this section, you must have previously made a reservation and received the email and confirmation code confirming your reservation. Customers who have only submitted a request cannot access this section.",
    logout: "Log Out",
    reservationsTab1: "Your Active Reservations",
    reservationsTab2: "Your Past Reservations",
    reservationsTab1Error: "No Active Reservations Found",
    reservationsTab2Error: "No Past Reservations Found",
    ReservationStatus0: "Pending Approval",
    ReservationStatus1: "Awaiting Payment",
    ReservationStatus1ActionBtn: "Submit Payment Notification",
    ReservationStatus1ActionCompleted: "Payment Notification Submitted",
    ReservationStatus1ActionBtn2: "Pay By Credit Card",
    ReservationStatus3: "Approved",
    ReservationStatus3Text: "Paid",
    ReservationStatus3ActionBtn: "Submit Payment Notification",
    ReservationStatus3ActionBtn2: "Please Enter Guest Information",
    ReservationStatus3ActionBtn2Completed: "Guest Information Entered",
    ReservationStatus4: "Cancelled",
    reservationNo: "Res. No",
    reservationDate: "Transaction Date / Time",
    reservationCustomerName: "Customer Name Surname",
    reservationDate1: "Check-In Date",
    reservationDate2: "Check-Out Date",
    reservationtionPrice: "Payment Amount",
    reservationGuestInformationTitle:
      "Please enter {name} information for Reservation number {reservationId}",
    reservationGuestInformationTitleName1: "Guest",
    reservationGuestInformationTitleName2: "Invoice details",
    reservationGuestInformationSubTitle:
      "You can accommodate up to {count} people.",
    GuestInformationTitle: "Guest Information {no}",
    GuestInformationName: "Full Name",
    GuestInformationGender: "Gender",
    GuestInformationGenderMale: "Male",
    GuestInformationGenderFemale: "Female",
    GuestInformationBirthDate: "Date of Birth",
    GuestInformationBirthPlace: "Place of Birth",
    GuestInformationPassaport: "Passport Number",
    GuestInformationTc: "TC Number",
    GuestInformationNotTurkeyPeople: "I'm not a Turkish citizen",
    goBack: "Go Back",
    save: "Save",
    GuestInformationInvoiceType: "Invoice Type",
    GuestInformationInvoiceTypeOption1: "Individual",
    GuestInformationInvoiceTypeOption2: "Corporate",
    GuestInformationInvoiceTypeOption1Name: "Full Name",
    GuestInformationInvoiceTypeOption2Name: "Company Name",
    GuestInformationInvoiceTaxOffice: "Tax Office",
    GuestInformationInvoiceTaxNumber: "Tax Number",
    address: "Address",
    GuestInformationSuccessfullyTitle:
      " Guest Information successfully received.",
    GuestInformationSuccessfullyDescription:
      "A summary of guest information has been sent to you by email. If you believe there is an error, please contact our Customer Service.",
    PayByCreditCardTitle: "Pay {price}",
    PayByCreditCardCaption: "Pay with Bank or Credit Card",
    PayByCreditCardFormName: "Full Name",
    PayByCreditCardFormCardNumber: "12-digit number on the card",
    PayByCreditCardFormSubmit: "Pay",
    PayByCreditCardRightTitle: "{night} Night Accommodation",
    PaymentAuthRequired: "You need to sign in to make a payment.",
    installementFull: "Single Payment",
    installement: "Installment",
    paymentSuccess: "Ödeme Başarılı",
    paymentSuccessDescription: "Bu pencereyi kapatabilirsiniz.",
    paymentTryAgain: "Lütfen Tekrar Deneyiniz",
    getOfferStep1Title1: "Welcome to the",
    getOfferStep1Title2: "Villa finder wizard.",
    getOfferStep1Caption1: "Are you having difficulty finding",
    getOfferStep1Caption2: "the villa you are looking for?",
    getOfferStep1SubTitle:
      "Easily find the villa you're looking for in just 5 steps.",
    getOfferNextBtn: "Next",
    getOfferPrevBtn: "Prev",
    getOfferSendBtn: "Send Form",
    getOfferStep2Title: "WHAT KIND OF VILLA HOLIDAY ARE YOU LOOKING FOR",
    getOfferStep2Option1: "ECONOMICAL",
    getOfferStep2Option2: "MID-RANGE",
    getOfferStep2Option3: "LUXURY",
    getOfferStep3Title: "WHAT ARE YOU PLANNING YOUR HOLIDAY FOR?",
    getOfferStep3Option1: "Honeymoon or Special Occasion",
    getOfferStep3Option2: "With Family or Friends",
    getOfferStep4Title: "FEATURES YOU WANT IN YOUR VILLA",
    getOfferStep5Title: "YOUR INFORMATION",
    getOfferFormFullName: "Full Name",
    getOfferFormEmail: "Your Email Address",
    getOfferFormPhone: "Your Phone Number",
    getOfferFormPerson: "Number of People",
    getOfferFormAdult: "Adult",
    getOfferFormChild: "Child",
    getOfferFormInfant: "Infant",
    getOfferFormError: "An error occurred",
    getOfferModalTitle: "THANK YOU",
    getOfferModalCaption:
      "The villa finder wizard has started working to find the most suitable options for you.",
    getOfferModalDescription:
      "The selected villas will be sent to you via SMS and email as soon as possible.",
    blogSidebarSearchTitle: "Search",
    blogSidebarSearchPlaceHolder: "Search Blog",
    blogSidebarList1Title: "Latest Posts",
    blogSidebarList2Title: "Popular Posts",
    blogItemReadBtn: "Read More",
    bankItemBankName: "Bank Name",
    bankItemBankBranch: "Branch Name-Code",
    bankItemBankAccountName: "Account Name",
    bankItemBankIban: "IBAN Number",
    checkinInformationTitle: "Reservation Details",
    viewInvoice: "View Invoice Details",
    viewContract: "View Contract Details",
    customerInformations: "Customer Information",
    villaManager: "Villa Manager/Attendant",
    callNow: "Call Now",
    sendMessageViaWp: "Message via WhatsApp",
    earliest: "Earliest",
    latest: "Latest",
    paymentInformations: "Payment Information",
    paymentOwnerInformation: "Payment Information Detail",
    remaining: "Remaining",
    accommodationPrice: "Total Accommodation Price",
    paymentCheckin: "Payment to be Made at Check-in during entrance",
    creditcardNotAccepted:
      "(Credit card <span class='underline'>not accepted</span>)",
    entranceInformationDamageDeposit:
      "The amount to be paid upon entering the villa. In addition, a damage deposit of {damage} will be taken.",
    entranceInformationLocationErrorOwner:
      "Please contact your guest and provide the location information!",
    entranceInformationLocationErrorCustomer:
      "Please contact the Villa Manager/Attendant and request location information!",
    UnconditionalmoneyTitle: "Within 24 Hours",
    UnconditionalmoneySubTitle: "Unconditional Money Back",
    UnconditionalmoneyDescription:
      "*If CANCELLATION occurs within 24 hours following the confirmation of the reservation, the visitor receives a refund of the deposit paid unconditionally.",
    UnconditionalmoneyDescription2:
      "Not valid for reservations with a check-in date within the earliest 21 days.",
    discount: "Discount",
    discountedAccommodationAmount: "Discounted Accommodation Amount",
    appliedDiscount: "{code} code applied",
    ihaveapromotioncode: "I Have a Promotion Code",
    promotionCode: "Promotion Code",
    apply: "Apply",
    callCenterName: "Call Center",
    allVillasCta: "All rental villas",
    allVillasCtaSub: "Browse every villa without picking dates",
    allVillasCtaStrip: "Browse all rental villas without picking dates",
    allVillasCtaRest: "and every other region",
    disableCalendarRules: "Disable Calendar Rules",
    roomCount: "Room Count",
    paybackDamageInfo:
      "It will be collected upon arrival and returned to you upon departure if there is no damage.",
    paymentByCompany: "The amount to be sent by the agency",
    paymentByCompanyInfo:
      "The amount to be sent by the agency will be sent to your account within 1-5 working days after the check-in date.",
    accountDelete: "Account Delete",
    rezervationCode: "Reservation Code",
    memberLogin: "Member Login",
    noAccount: "Don't have an account?",
    register: "Sign Up",
    forgotPassword: "Forgot Password",
    loginError: "An error occurred while logging in.",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    updatePassword: "Update Password",
    otpCode: "Verification Code",
    verifyCode: "Verify Code",
    resendCode: "Resend Code",
    otpRequired: "Verification code is required",
    otpLength: "Code must be 6 digits",
    otpError: "Code could not be verified.",
    otpResendSuccess: "Verification code has been resent.",
    otpResendError: "Code could not be resent.",
    passwordRequired: "Password is required",
    passwordMin: "Password must be at least 6 characters",
    passwordsNotMatch: "Passwords do not match",
    passwordUpdateSuccess: "Your password has been successfully updated!",
    passwordUpdateError: "Password could not be updated.",
    completeRegistration: "Complete Registration",
    nameRequired: "Name is required",
    surnameRequired: "Surname is required",
    emailRequired: "Email is required",
    emailInvalid: "Please enter a valid email",
    registrationSuccess: "Your account has been created!",
    registrationError: "Registration could not be completed.",
    password: "Password",
    sendResetCode: "Send Reset Code",
    backToLogin: "Back to Login",
    createNewPassword: "Create New Password",
    continue: "Continue",
    phoneRequired: "Phone number is required",
    phoneInvalid: "Please enter a valid number",
    operationFailed: "Operation failed.",
    newPasswordRequired: "New password is required",
    confirmPasswordRequired: "Password confirmation is required",
    // --- New texts (site 2 translation) ---
    faqTitle: "Frequently Asked Questions",
    instagramSubtitle: "Holiday Villas for Rent",
    instagramText: "Follow us to discover the most special villas in and around Fethiye and see our guests' experiences.",
    instagramFollow: "Follow on Instagram",
    discountedBadge: "Discounted",
    instantBooking: "Instant Booking",
    googleReviewsTitle: "Google Guest Reviews",
    googleReviewsCount: "1,179 Real Reviews",
    viewAllReviews: "View all reviews",
    excellent: "Excellent",
    weekly: "Weekly",
    workingHours: "Working Hours",
    noResultFound: "No Results Found",
    mobileMenuLabel: "Mobile Menu",
    copied: "Copied!",
    reviewCtaTitle: "Have You Stayed With Us?",
    reviewCtaThisVilla: "this villa",
    reviewCtaText: "— how was your stay? Share your experience with us and other guests to help them choose.",
    ministryOfTourism: "Republic of Türkiye Ministry of Culture and Tourism",
    applicationNo: " Application No: ",
    applicationInProgress: " Application in Progress",
    cancel: "Cancel",
    clearSelection: "Clear selection",
    sidebarPayNowText: "Pay now without waiting for pre-approval and complete your reservation.",
    bedroom1: "Bedroom 1",
    bedroom2: "Bedroom 2",
    garden: "Garden",
    doubleBed: "Double Bed",
    bathroomDoubleBed: "Bathroom Double Bed",
    poolLength: "Length",
    poolWidth: "Width",
    poolDepth: "Depth",
    directionsAria: "Get directions to our office",
    timeAlmostUp: "Time Is Running Out!",
    paymentTime: "Payment Time",
    timeLeftToComplete: "Time left to complete your reservation",
    dayShort: "Days",
    feedbackThanks: "Thank you for your feedback...",
    feedbackChooseRating: "Please select a valid rating.",
    feedbackAsk: "Our website has been renewed. Would you like to rate our new website?",
    no: "No",
    yourRating: "Your Rating",
    pleaseSelect: "Please select",
    certificateLabel: "Certificate",
    certificateNo: " No: ",
    rentableNow: "Available to Book Instantly",
    errorTitle: "Error",
    warningTitle: "Warning",
    attention: "Attention",
    hoursLabel: "Hours",
    minutesLabel: "Minutes",
    secondsLabel: "Seconds",
    followUs: "Follow Us",
    ourOffice: "Our Office",
    getDirections: "Get Directions",
    footerAddress: "Akarca District, Adnan Menderes Boulevard No:205/C 1-2-3, Fethiye / Muğla, Türkiye",
    learnMore: "Learn more",
    favouritesAria: "Favourites",
    favouriteAria: "Favourite",
    writeReviewShort: "Write a Review",
    googleWriteReview: "Review Us on Google",
    nightLabel: "Nights",
    moreInfo: "More Info",
    free: "Free",
    dateLabel: "Date",
    amountLabel: "Amount",
    statusLabel: "Status",
    feeLabel: "Fee",
    statusAvailable: "Available",
    statusUnavailable: "Unavailable",
    serviceFreePre: "For the available dates you can use this service",
    serviceFreeStrong: "free of charge.",
    serviceFreePost: "",
    servicePaidPre: "A total fee of",
    servicePaidPost: "will be charged for the available dates.",
    mobileAppDiscount: "Mobile app exclusive discount",
    promoCodeDiscount: "Promotion Code Discount",
    heatedPool: "Heated Pool",
    optionalServices: "Optional Services",
    heatingPoolTitle: "Heated Pool Fees and Availability",
    notUsable: "Not available",
    usable: "Available",
    closeBtn: "Close",
    wantHeatedPool: "I would like to use the heated pool",
    heatedPoolDatesPre: "To see the dates when the heating service is available",
    heatedPoolDatesClick: "click here",
    availableDatesText: "Available dates for booking this property",
    selectBtn: "Select",
    loadingDots: "Loading...",
    continueAnyway: "Continue Anyway",
    availableDatesWarning: "This usually has a negative outcome. However, if you wish, we can review your request again or you can choose from alternative dates.",
    payNow: "Pay now",
    contactAddress: "Address",
    contactPhoneEmail: "Phone & Email",
    contactShare: "Share",
    contactForm: "Contact Form",
    contactFullName: "Your Full Name",
    contactPhone: "Your Phone Number",
    contactEmail: "Your Email Address",
    contactSubject: "Subject",
    contactMessage: "Your Message",
    contactSecurityCode: "Security Code",
    contactSecurityCodeEnter: "Enter the Security Code",
    contactSendForm: "SEND FORM",
    contactMap: "Map",
    creditCardInstantNote: "When you choose to pay by credit card, your reservation will be completed instantly and confirmed without any approval process.",
    cardNumberLength: "Card number must be 16 digits.",
    paymentStatusChecking: "Checking payment status...",
    paymentSuccessToast: "Payment Successful",
    closeWindowAfterPayment: "You can close this window after completing your payment.",
    clickToPay: "Click to Make a Payment",
    installments369: "3-6-9 instalments available on all bank cards",
    bankRatesApply: "The rates set by the banks apply",
    successTitle: "Successful",
    paymentReceived: "Your payment has been received successfully.",
    paymentInfoSentTo: "– payment details have been sent to this address.",
    contactAndPaymentInfo: "Contact and Payment Information",
    fullNameLabel: "Full Name",
    creditCardInfo: "Credit Card Information",
    cardNumberLabel: "Card Number",
    loadingShort: "Loading",
    payBtn: "Pay",
    sslNotice: "Payments you make via {domain} are encrypted with a 256-Bit SSL Certificate and sent to the bank. Information is exchanged securely between your bank and {site}, and your card details are not stored in any database.",
    heatedPoolFee: "Heated Pool Fee",
    sliderCaptionDefault: "Start your holiday in a villa with a private pool",
    ownerWelcomeBack: "Welcome back,",
    ownerPanelTitle: "Villa Owner Management Panel",
    ownerCopyright: "2021 @ All Rights Reserved. Content may not be used without permission.",
    ownerWelcome: "Welcome.",
    ownerIntroPre: "You can follow or manage your villas from this section with the e-mail address and password given to you. If you encounter any problem with your villas, please contact our customer service urgently:",
    ownerIntroLink: "contact us.",
    ownerLoginError: "Incorrect username or password.",
    usernameLabel: "Username",
    passwordLabel2: "Password",
    loginBtn2: "Log In",
    advertiseQPre: "Are You a ",
    advertiseQStrong: "Villa ",
    advertiseQPost: "Owner?",
    advertiseFormReceived: "Your form has been received. Our relevant department will get back to you as soon as possible. Thank you for your interest.",
    poolPrivate: "Private Pool",
    poolShared: "Shared Pool",
    poolNone: "No Pool",
    seaViewLabel: "Sea View",
    yesLabel: "Yes",
    noLabel: "No",
    yourMessagePlaceholder: "Your message",
    advInfo1Title: "ACCURATE PRICING AND EARNINGS PLANNING",
    advInfo1Text: "We compare your villa with similar properties, taking into account its features, capacity and location, and prepare the most accurate pricing study, including a detailed seasonal earnings scenario.",
    advInfo2Title: "PROFILE AND LISTING MANAGEMENT",
    advInfo2Text: "Together with our expert team, we present your villa to the right audience through targeted advertising. With effective social media management and experience, we work meticulously to help you reach the highest occupancy.",
    advInfo3Title: "24/7 GUEST SUPPORT LINE",
    advInfo3Text: "With our 7 days / 24 hours call center service, we respond instantly to our guests' requests and questions. We provide continuous support, regardless of day or time.",
    advInfo4Title: "PROFESSIONAL PHOTO & VIDEO SHOOTS",
    advInfo4Text: "Photography is one of the most important factors in promoting a villa, and our professional team takes care of it. Our shoots are carried out meticulously using methods suitable for effective use in advertising and on social media accounts.",
    advInfo5Title: "EVALUATION AND INFORMATION",
    advInfo5Text: "To help your villa reach maximum occupancy, you can get evaluations and detailed information from our experienced team from start to finish on topics such as interior and exterior design and the contribution of equipment features, so you can receive more booking requests.",
    ptdTitle1: "Pay on",
    ptdTitle2: "Arrival",
    ptdTitle3: "System",
    ptdP1: "requires an ADVANCE PAYMENT of between 15% and 40%, depending on the villa, at the reservation stage.",
    ptdP2: "You can pay the remaining amount to the Villa Owner on the day you check in to the villa.",
    ptdP3: "How the villa owner will collect your REMAINING payment is stated in the EMAIL you receive at the reservation stage.",
    refundTitle1: "In Case of Problems Caused by the Villa Owner",
    refundTitle2: "100% Money Back",
    refundP1Pre: "This applies if you cannot reach the villa owner within 6 hours of your check-in time at the villa you reserved for your holiday, or if the villa differs from the one shown in the photos (excluding furniture and decoration changes). The full amount you have paid will be",
    refundP1Strong: "refunded",
    refundP1Post: "to you.",
    refundP2: "works to make up for this inconvenience: our Sales Consultants will help you find an available villa in the same region at a discounted rate, with no commission earned, so that you can continue your holiday.",
    refundP3: "For any problems you may experience during your holiday other than these cases, {site} will help resolve the issue as quickly as possible and, if it cannot be resolved, help you move to a different villa if one is available.",
    securaTitle1: "Secure",
    securaTitle2: "Payment",
    securaTitle3: "System",
    securaP1Pre: "is a",
    securaP1Company: "Coşkunlar Ticaret Emlak Turizm İnşaat Limited Şirketi",
    securaP1Post: "company.",
    securaP2: "Our website uses the SSL protocol encryption system (impossible to decrypt), a 256-bit secure site and the 3D Secure payment system.",
    securaP3: "You can pay by credit card through the Virtual POS system or by bank transfer / EFT to our official company accounts.",
    securaPolicyTitle: "This Privacy Policy:",
    securaPolicyText: "covers all users who visit and use {domain} and is accepted in advance. The data that visitors using {domain} provide to us directly and/or indirectly is described below. This data is used only in the cases permitted under the Rental and Use Agreement and the terms of the Privacy Policy, and is not used outside those cases.",
    installPre: "Make your reservation now,",
    installMid: "and pay comfortably by credit card in instalments. {site} offers up to 12 instalments on all credit cards.",
    installNote: "Interest rates for instalment options are determined by your bank. Before making your reservation, you can check the rates applied by your bank and take advantage of the instalment option.",
    installUpTo: "Up to 12 instalments",
    installTursab: "{site} Tourism Travel Agency is affiliated with the Republic of Türkiye Ministry of Tourism with TÜRSAB Certificate A-14264.",
    paidAccommodationAmount: "Accommodation Amount Paid",
    remainingAccommodationAmount: "Remaining Accommodation Amount",
  },
};

export const language = languages[process.env.NEXT_PUBLIC_LANGUAGE];
